export const SET_SELECTED_UNIT_WIZARD = "@@wizard/SET_SELECTED_UNIT_WIZARD";

export function setSelectedUnit(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_SELECTED_UNIT_WIZARD,
      payload: value,
    });
  };
}

export const SET_WIZARD_INITIALIZED = "@@wizard/SET_WIZARD_INITIALIZED";

export function setWizardInitialized(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_WIZARD_INITIALIZED,
      payload: value,
    });
  };
}
